/**
 * Geeklist class
 * 
 * Represents a BoardGameGeek geeklist with its metadata.
 */
class Geeklist {
    constructor(id, title, username, numItems) {
        this.id = id;
        this.title = title;
        this.username = username;
        this.numItems = numItems;
    }

    /**
     * Create a Geeklist from API response data
     * @param {Object} data - Raw API data
     * @returns {Geeklist}
     */
    static fromApiResponse(data) {
        return new Geeklist(
            data.id,
            data.name || data.title,
            data.creator?.username || data.username || 'Unknown',
            data.numitems || data.numItems || 0
        );
    }
}

export default Geeklist;